import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableCustomerOrderMonitorRoutes = Loadable(
  './CustomerOrderMonitorRoutes',
  () => import(/* webpackChunkName: "CustomerOrderMonitor" */ './CustomerOrderMonitorRoutes'),
  () => [(require as any).resolveWeak('./CustomerOrderMonitorRoutes')]
);
